import { render, staticRenderFns } from "./Instructions.vue?vue&type=template&id=2df57f56&scoped=true"
import script from "./Instructions.vue?vue&type=script&lang=js"
export * from "./Instructions.vue?vue&type=script&lang=js"
import style0 from "./Instructions.vue?vue&type=style&index=0&id=2df57f56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df57f56",
  null
  
)

export default component.exports